import React, { Fragment, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/LoaderSpinner";
import moment from "moment";
import {
  getStudentProfileForUpdateOnly,
  getStudentProfileByFormNumber,
  getPayableFeeForStudent,
  savePaymentRecords,
  resetStudentProfile,
  generateStudId,
  generateClassRollNumber
} from "../../api/admissionApi";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: "block",
    float: "left",
    border: "0px"
  },
  tableHead: {
    display: "block",
    borderLeft: "1px solid #eee",
    borderRight: "1px solid #eee",
    borderBottom: "1px solid #eee",
    borderTop: "0px",
    fontWeight: "bold"
  },
  tableData: {
    display: "block",
    textAlign: "left",
    marginLeft: "12rem"
  }
}));

function GenerateRollNumber({ permissions = {}, isSuperAdmin }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      isStudent,
      faculty_id
    } = {},
    admissionReducer: {
      isAdmissionsOpen = false,
      admissionPageInfo = {},
      isFetchingExistingAdmsnPageInfo = false,
      isUserProfileLoading = false,
      isAdmissionPageInfoLoaded = false,
      admissionPageInfoFailed,
      studentProfile = {},
      filteredReg = [],
      fetchingReg
    }
  } = state;
  const [searchByFormNumber, setSearchByFormNumber] = useState("");
  const [searchByEmail, setSearchByEmail] = useState("");
  const [isGeneratingStudId, setIsGeneratingStudId] = useState(false);
  const [isGeneratingRollNo, setIsGeneratingRollNo] = useState(false);
  
  const getStudProfileByEmail = (email, cbs) => dispatch(getStudentProfileForUpdateOnly(email, cbs));
  const getStudProfileByFormNo = (formNumber, cbs) => dispatch(getStudentProfileByFormNumber(formNumber, cbs));

  const generateStuId = (data, cbs) => dispatch(generateStudId(data, cbs));
  const generateClassRoll = (data, cbs) => dispatch(generateClassRollNumber(data, cbs));


  useEffect(()=> {
    dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [] } });
  }, [])

  const resetAll = () => {
    dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [] } });
  }

  const fetchStudentInfo = () => {
    dispatch({ type: 'FETCH_REGISTRATIONS', payload: true });
    const callbacks = {
      successCallback: getStudentProfileSuccessCallback,
      failureCallback: getStudentProfileFailureCallback,
    };
    if (!isStudent && searchByFormNumber)
      getStudProfileByFormNo(searchByFormNumber, callbacks);
    else if (!isStudent && searchByEmail)
      getStudProfileByEmail(searchByEmail, callbacks);
    else toast.error("You are not permitted to search student profile.");
  };

  const getStudentProfileSuccessCallback = (data = {}) => {
    console.log("getStudentProfileSuccessCallback:", data.profileDetails);
    dispatch({ type: 'FETCH_REGISTRATIONS', payload: false });

    dispatch({ type: 'SAVE_REGISTRATIONS', payload: { registrations: [data.profileDetails] } });
    if(studentProfile.is_registration_completed)toast.success("Student profile fetched successfully.");
    else toast.success("Data fetched.");
  };

  const getStudentProfileFailureCallback = (errData) => {
    dispatch({ type: 'FETCH_REGISTRATIONS', payload: false });
    if(errData.data.registrations) toast.error("No registrations found with provided value.");
    if (errData !== undefined && errData.data) toast.error(errData.data.err);
    else alert("Error with your network, please try again!");
  };

  const renderStudentSearchFilters = () => {
    return (
      <Fragment>
        <div className="d-flex mb-4 align-items-center">
          Enter Form/Registration Number:
          <input
            type="text"
            className="form-control w-25 ml-3"
            placeholder="Form no./Reg. no"
            value={searchByFormNumber}
            onChange={(e) => {
              setSearchByEmail("");
              setSearchByFormNumber(e.target.value);
              resetAll();
            }}
            onKeyUp={(e) => {
              e.keyCode === 13 && fetchStudentInfo();
            }}
          />
        </div>
        <p>-- OR --</p>
        <div className="d-flex mb-4 align-items-center">
          Enter Student's email:
          <input
            type="email"
            className="form-control w-25 ml-3"
            placeholder="Email id"
            value={searchByEmail}
            onChange={(e) => {
              setSearchByFormNumber("");
              setSearchByEmail(e.target.value);
              resetAll();
            }}
            onKeyUp={(e) => {
              e.keyCode === 13 && fetchStudentInfo();
            }}
          />
        </div>
        <div className="d-flex align-items-center mt-3 mb-15">
          <button
            className="btn btn-primary"
            type="button"
            disabled={
              isUserProfileLoading || (!searchByFormNumber && !searchByEmail)
            }
            onClick={fetchStudentInfo}
          >
            {isUserProfileLoading ? <LoaderSpinner /> : "Search student"}
          </button>
        </div>
      </Fragment>
    );
  };

  const generateStudentId = (formNumber) => {
    setIsGeneratingStudId(true);
    const requestParam = {
      formNumber: formNumber,
      generatedBy: faculty_id
    };
    const callbacks = {
      successCallback: (resp) => {
        toast.success("Student ID generated successfully.");
        refreshList(formNumber, "studentID", resp);
        setIsGeneratingStudId(false);
      },
      failureCallback: generateIdFailureCallback,
    };
    generateStuId(requestParam, callbacks)
  };
  const generateClassRollNo = (formNumber) => {
    setIsGeneratingRollNo(true);
    const requestParam = {
      formNumber: formNumber,
      generatedBy: faculty_id
    };
    const callbacks = {
      successCallback: (resp) => {
        toast.success("Student class roll number generated successfully.");
        refreshList(formNumber, "classRollNo", resp);
        setIsGeneratingRollNo(false);
      },
      failureCallback: generateIdFailureCallback,
    };
    generateClassRoll(requestParam, callbacks);
  };

  const generateIdFailureCallback = (errData) => {
    // console.log("generateIdFailureCallback: ", errData);
    toast.error(errData.err);
    setIsGeneratingStudId(false);
    setIsGeneratingRollNo(false);
  };


  const refreshList = (formNumber, action, value) => {
    //EITHER CALL BELOW API OR UPDATE REDUX STATE

    if(value.data) {
      //UPDATE REDUX STATE
      let currentFilteredUser = filteredReg[0];
      if(currentFilteredUser.formNumber === formNumber){
        if(action === "studentID") currentFilteredUser.student_id = value.data;
        else if(action === "classRollNo") currentFilteredUser.class_roll_number = value.data;
      }
      dispatch({ type: 'UPDATE_REGISTRATIONS', payload: { registrations: [currentFilteredUser] } });
    } else {
      //API CALL
      setSearchByFormNumber(formNumber);
      fetchStudentInfo();
    }
  }

  const renderRegistrations = () => {
    if (!filteredReg.length) return null;
    return (
      <Fragment>
      {/* <div className="table-responsive">
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
          <thead>
            <tr className={classes.tableRow}>
              <th className={classes.tableHead} >Name</th>
              <th className={classes.tableHead} >Email Id</th>
              <th className={classes.tableHead} >Phone</th>
              <th className={classes.tableHead} >Reg. status</th>
              <th className={classes.tableHead} >Form Number</th>
              <th className={classes.tableHead} >College fees</th>
              <th className={classes.tableHead} >Entrance roll no.</th>
              <th className={classes.tableHead} >Exam status</th>
              <th className={classes.tableHead} >Course fee</th>
              <th className={classes.tableHead} >Student ID</th>
              <th className={classes.tableHead} >Class roll no.</th>
            </tr>
          </thead>
          <tbody >
            {filteredReg.map((reg = {}, idx) => {
              const { formNumber, entranceRollNumber, student_id = "", class_roll_number="", full_name: { first_name = '', last_name = '' } = {}, examination_status :{is_examination_passed = false} = {} } = reg;
              return (
                <tr className={classes.tableRow} key={idx}>
                  <td className={classes.tableData} ><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                  <td className={classes.tableData} >{reg.email_id}</td>
                  <td className={classes.tableData} >{reg.mobile_number}</td>
                  <td className={classes.tableData} >
                    {reg.is_registration_completed ? <span style={{ background: 'limegreen' }}>{'Complete'}</span> : <span style={{ background: 'yellow' }}>{'Pending'}</span>}
                  </td>
                  <td className={classes.tableData} >{formNumber}</td>
                  <td className={classes.tableData} >
                    {
                      (reg.payment_status.isCollegeFeePaid && reg.payment_status.collegeFeesPaidDate) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span>:
                      (reg.payment_status.isCollegeFeePaid && !reg.payment_status.collegeFeesPaidDate) ? <span>Paid</span> :
                      <span>{`Un-Paid`}</span>
                    }
                  </td>
                  <td className={classes.tableData} >
                    {entranceRollNumber}
                  </td>
                  <td className={classes.tableData} >
                  {is_examination_passed ? <span style={{ background: 'limegreen' }}>{'Passed'}</span> : <span style={{ background: 'yellow' }}>{'Failed'}</span>}
                  </td>
                  <td className={classes.tableData} >
                    {
                      (reg.payment_status.total_fee_paid && reg.payment_status.isPaymentVerified) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span>:
                      (reg.payment_status.total_fee_paid && !reg.payment_status.isPaymentVerified) ? <span>Paid</span> :
                      <span>{`Un-Paid`}</span>
                    }
                  </td>

                  <td className={classes.tableData} >
                    {student_id ? `${student_id}` : <div>
                      <button disabled={student_id} type="button" className="btn btn-outline-primary mr-10" 
                      onClick={()=> generateStudentId(formNumber)}
                      >Generate</button>
                    </div>}
                  </td>
                  <td className={classes.tableData}>
                    {class_roll_number ? `${class_roll_number}` : <div>
                      <button disabled={class_roll_number} type="button" className="btn btn-outline-primary mr-10" 
                      onClick={()=> generateClassRollNo(formNumber)}
                      >Generate</button>
                    </div>}
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}

        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
        <tr className={classes.tableRow}>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Name</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Email Id</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Phone</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Reg. status</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Form Number</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>College fees</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Entrance roll no.</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Exam status</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Course fee</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Student ID</th>
          <th className={classes.tableHead} style={{fontWeight: "bold", color: "black"}}>Class roll no.</th>
        </tr>
            {filteredReg.map((reg = {}, idx) => {
              const { formNumber, entranceRollNumber, student_id = "", class_roll_number="", full_name: { first_name = '', last_name = '' } = {}, examination_status :{is_examination_passed = false} = {} } = reg;
              return(
                <div key={idx} style={{lineHeight: "23px"}}>
                  <td className={classes.tableData} style={{border: "0px"}}><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                  <td className={classes.tableData} style={{border: "0px"}} >{reg.email_id}</td>
                  <td className={classes.tableData} style={{border: "0px"}} >{reg.mobile_number}</td>
                  <td className={classes.tableData} style={{border: "0px"}} >
                    {reg.is_registration_completed ? <span style={{ background: 'limegreen' }}>{'Complete'}</span> : <span style={{ background: 'yellow' }}>{'Pending'}</span>}
                  </td>
                  <td className={classes.tableData} style={{border: "0px"}} >{formNumber ? `${formNumber}` : 'N/A'}</td>
                  <td className={classes.tableData} style={{border: "0px"}} >
                    {
                      (reg.payment_status?.isCollegeFeePaid && reg.payment_status?.collegeFeesPaidDate) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span>:
                      (reg.payment_status?.isCollegeFeePaid && !reg.payment_status?.collegeFeesPaidDate) ? <span>Paid</span> :
                      <span>{`Un-Paid`}</span>
                    }
                  </td>

                  <td className={classes.tableData} style={{border: "0px"}} >
                    {entranceRollNumber ? `${entranceRollNumber}` : 'N/A'}
                  </td>
                  <td className={classes.tableData} style={{border: "0px"}} >
                  {is_examination_passed ? <span style={{ background: 'limegreen' }}>{'Passed'}</span> : <span style={{ background: 'yellow' }}>{'Failed'}</span>}
                  </td>

                  <td className={classes.tableData} style={{border: "0px"}} >
                    {
                      (reg.payment_status?.total_fee_paid && reg.payment_status?.isPaymentVerified) ? <span style={{ background: 'limegreen' }}>{`Paid & Verified`}</span>:
                      (reg.payment_status?.total_fee_paid && !reg.payment_status?.isPaymentVerified) ? <span>Paid</span> :
                      <span>{`Un-Paid`}</span>
                    }
                  </td>

                  <td className={classes.tableData} style={{border: "0px"}} >
                    {student_id ? `${student_id}` : <div>
                      <button disabled={student_id} type="button" className="btn btn-outline-primary mr-10" 
                      onClick={()=> generateStudentId(formNumber)}
                      >Generate</button>{isGeneratingStudId && <LoaderSpinner />}
                    </div>}
                  </td>
                  <td className={classes.tableData} style={{border: "0px"}} >
                    {class_roll_number ? `${class_roll_number}` : <div>
                      <button disabled={class_roll_number} type="button" className="btn btn-outline-primary mr-10" 
                      onClick={()=> generateClassRollNo(formNumber)}
                      >Generate</button>{isGeneratingRollNo && <LoaderSpinner />}
                    </div>}
                  </td>
                </div>
              )
            })}
        </table>
        </Fragment>
    );
  }

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Generate roll number</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Generate roll number
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Generate roll numbers for admission</h3>
        </div>

        <div className="card-body">
          <p className="text-primary">Though the student Id and roll number are generated automatically when the payment status is recorded in previous step, but in case of any failure use this page to generate student Id and roll number manually:</p>
          {renderStudentSearchFilters()}
          {renderRegistrations()}
        </div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default GenerateRollNumber;
